import DocumentsSearchInput from "./DocumentsSearchInput";
export default DocumentsSearchInput;
